import React from "react";
import { DocumentDetails } from "../../../components";
import * as routes from "../../../app/routes";
import { useParams } from "react-router-dom";
import * as modules from "../../../utils/modules";

function SalesDetails() {
  const parameters = useParams<{ id: string }>();
  const id = parameters.id || "";

  return (
    <DocumentDetails
      module={modules.MODULE_SALES}
      operationCode={id}
      headerRoute={routes.ROUTE_SALES.path}
    />
  );
}

export default SalesDetails;
